import { render, staticRenderFns } from "./PaymentDashboard.vue?vue&type=template&id=0f20d0a8"
import script from "./PaymentDashboard.vue?vue&type=script&lang=js"
export * from "./PaymentDashboard.vue?vue&type=script&lang=js"
import style0 from "./PaymentDashboard.vue?vue&type=style&index=0&id=0f20d0a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports